// smartLockHelpers.js 


import { fetchSmartLocks, getLockStatus } from "../../services/SmartLocksService";

/**
 * Load initial locks from Seam and fetch their status.
 * @param {string} uid - The current user's UID.
 * @returns {Promise<Array>} - Array of locks with their status.
 */
export const loadLocksHelper = async (uid) => {

  try {
    const locksData = await fetchSmartLocks(uid);

    // Resolve status for each lock
    const locksWithStatus = await Promise.all(
      locksData.map(async (lock) => {
        try {
          const statusData = await getLockStatus(lock.lockId);
          return {
            ...lock,
            isLocked: statusData.locked,
            locked: statusData.locked,
            online: statusData.online,
            isOnline: statusData.online,
            batteryLevel: statusData.battery_level,
            battery_level: statusData.battery_level,
            manufacturer: statusData.manufacturer || lock.manufacturer,
          };
        } catch (error) {
          console.error(`loadLocksHelper: Failed to get status for lock ${lock.lockId}:`, error);
          return { ...lock, isLocked: false };
        }
      })
    );

    return locksWithStatus;
  } catch (error) {
    console.error("loadLocksHelper: Error fetching smart locks:", error);
    throw error;
  }
};

/**
 * Poll the lock statuses for an existing array of locks.
 * @param {Array} locks - An array of current locks.
 * @param {string} uid - The current user's UID.
 * @returns {Promise<Array>} - Updated array of locks with latest status.
 */
export const pollLockStatusHelper = async (locks, uid) => {

  return Promise.all(
    locks.map(async (lock) => {
      try {
        const statusData = await getLockStatus(lock.lockId);
        return {
          ...lock,
          isLocked: statusData.locked,
          locked: statusData.locked,
          online: statusData.online,
          isOnline: statusData.online,
          batteryLevel: statusData.battery_level,
          battery_level: statusData.battery_level,
          manufacturer: statusData.manufacturer || lock.manufacturer,
        };
      } catch (error) {
        console.error(`pollLockStatusHelper: Error polling lock ${lock.lockId}:`, error);
        return lock;
      }
    })
  );
};
